import * as React from 'react';

import UnitTemplateMini from '../assignment_flow/unit_templates_manager/unit_template_mini';
import { NOVEL_BASED_ACTIVITY_PACK_IDS } from '../../constants/contentHubs';
import { requestGet } from '../../../../modules/request';
import { Spinner } from '../../../Shared/index';

const NovelBasedActivityPacks = () => {
  const [models, setModels] = React.useState(null)
  const [signedInTeacher, setSignedInTeacher] = React.useState(false)

  // The whole card is a link; the Preview & Assign button is a display-only
  // affordance we only surface to signed-in teachers inside the assignment flow.
  const inAssignmentFlow = window.location.pathname.startsWith('/assign')

  React.useEffect(() => {
    requestGet(`/teachers/unit_templates?ids=${NOVEL_BASED_ACTIVITY_PACK_IDS.join(',')}`, (data) => {
      const unitTemplatesById = {}
      data.unit_templates.forEach(unitTemplate => { unitTemplatesById[unitTemplate.id] = unitTemplate })
      setModels(NOVEL_BASED_ACTIVITY_PACK_IDS.map(id => unitTemplatesById[id]).filter(Boolean))
    })
    requestGet('/current_user_json', (data) => {
      setSignedInTeacher(!!(data && data.id))
    })
  }, [])

  return (
    <section className="novel-based-activity-packs">
      <div className="container">
        <h2>Novel-Based Activity Packs</h2>
        <p className="subhead">These activity packs are organized by commonly taught works of literature for grades 6 and up and can be used to support any ELA curriculum.</p>
        {models === null
          ? <Spinner />
          : (
            <div className="unit-template-minis">
              {models.map((model, index) => (
                <div className="unit-template-mini-wrapper" key={model.id}>
                  <UnitTemplateMini
                    data={model}
                    index={index}
                    showPreviewAndAssign={signedInTeacher && inAssignmentFlow}
                    signedInTeacher={signedInTeacher}
                  />
                </div>
              ))}
            </div>
          )}
      </div>
    </section>
  )
}

export default NovelBasedActivityPacks
